export default __webpack_public_path__ + "static/media/widget-query-dashboard.79b0627f.png";